import { PressureMonitoringConfiguration } from '@api/model/pressureMonitoringConfiguration';
import { Selector } from '@ngxs/store';
import { IPressureState, PressureState } from './pressure.state';

export class PressureSelectors {
    @Selector([PressureState])
    public static getAllLocationConfiguration(state: IPressureState): PressureMonitoringConfiguration {
        return state?.configuration;
    }

    @Selector([PressureState])
    public static getAllPressureSensor(state: IPressureState) {
        return state?.pressureSensors;
    }

    @Selector([PressureState])
    public static getSelectedAsset(state: IPressureState) {
        return state?.selectedAsset;
    }
}
